import React, { useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { DialogType, loginStore } from "@/modules/login/store";
import styles from "../style.module.scss";
import Banner from "../components/Banner";
import Nav from "../components/Nav";
import { ReactComponent as BackToTopSvg } from "@/assets/icons/mySpace/back-to-top.svg";
import { HeaderWithLogin } from "@/modules/login/ui";
import { Spinner } from "@chakra-ui/react";
import { useMount } from "ahooks";
import { otherSpaceStore } from "./store";
import Reels from "../components/Reels";
import { cancelFollow, createFollow, getSetsList } from "../api/mySpace";
import { toJS } from "mobx";
import { useHistory } from "react-router";

export type TabKey = "REELS";
const LOCAL_TAB_KEY = "OTHER_SPACE_ACTIVE_TAB";
const Tabs: { keyName: TabKey; name: string }[] = [
  {
    keyName: "REELS",
    name: "作品集",
  },
];

const OtherSpace: React.FC<any> = ({ ...props }) => {
  const {
    match: { params },
  } = props;
  const info = loginStore.userState.userInfo;
  const history = useHistory();
  const scrollDom = useRef<any>(null);
  useMount(() => {
    if (String(info.userId) === String(params.userId)) {
      history.push("/my_space");
    }
  });
  useMount(() => {
    getBannerInfo(params.userId);
  });

  loginStore.setGlobalLoading(false);
  const [tabVisible, setTabVisible] = useState<boolean>(true);
  const [activeTab, setActiveTab] = useState<TabKey>(defaultTab());
  const {
    loading: otherSpaceLoading,
    bannerUserBaseInfo,
    bannerUserStatisticsInfo,
    getBannerInfo,
  } = otherSpaceStore;
  const switchTab = (key: string) => {
    setActiveTab(key as TabKey);
    localStorage.setItem(LOCAL_TAB_KEY, key);
  };
  function defaultTab(): TabKey {
    // const activeTab = localStorage.getItem(LOCAL_TAB_KEY);
    // if (activeTab) {
    //   return activeTab as TabKey;
    // }
    return "REELS";
  }
  // useMount(() => {
  //   const activeTab = localStorage.getItem(LOCAL_TAB_KEY);
  //   if (activeTab) {
  //     setActiveTab(activeTab as TabKey);
  //   }
  // });

  const handleFollow = async () => {
    // 需要查看登陆状态，如果没有登陆，应该引导登陆
    if (!loginStore.isLogin) {
      loginStore.openLoginDialog({}, async () => {
        const res = await createFollow({ to_user_id: params.userId });
        getBannerInfo(params.userId);
      });
      return;
    }

    // 如果已经登陆，走登陆逻辑
    const res = await createFollow({ to_user_id: params.userId });
    if (res.code === 0) {
      // success
    } else {
      // error
    }
    getBannerInfo(params.userId);
    // 登陆后 刷新 banner 信息
  };

  const handleCancelFollow = async () => {
    if (!loginStore.isLogin) {
      loginStore.openLoginDialog({}, async () => {
        const res = await cancelFollow({ to_user_id: params.userId });
        getBannerInfo(params.userId);
      });
      return;
    }
    const res = await cancelFollow({ to_user_id: params.userId });
    if (res.code === 0) {
      // success
    } else {
      // error
    }
    getBannerInfo(params.userId);
  };

  const handleBackTop = () => {
    scrollDom.current?.scrollTo({ top: 0, behavior: "smooth" });
  };

  const content = useMemo(() => {
    switch (activeTab) {
      case "REELS":
        return <Reels userId={params.userId} />;
      default:
        return null;
    }
  }, [activeTab, params.userId]);

  return (
    <div className={styles["space-scroll-wrapper"]} ref={scrollDom}>
      <HeaderWithLogin />
      <div className={styles["space-wrapper"]}>
        <Banner
          baseInfo={bannerUserBaseInfo}
          statisticsInfo={bannerUserStatisticsInfo}
          isGuest={true}
          createFollow={handleFollow}
          cancelFollow={handleCancelFollow}
        />
        <Nav
          curActive={activeTab}
          switchTab={switchTab}
          tabs={Tabs}
          handleEleVisible={() => setTabVisible(true)}
          handleEleUnVisible={() => setTabVisible(false)}
        />
        {content}
      </div>
      {otherSpaceLoading && (
        <div className={styles["loading-wrapper"]}>
          <Spinner className={styles["loading-anim"]} />
        </div>
      )}
      {!tabVisible && (
        <div className={styles["go-back-to-top"]} onClick={handleBackTop}>
          <BackToTopSvg />
        </div>
      )}
    </div>
  );
};

export default observer(OtherSpace);
